export enum ECalculatorEvent {
  onSubmit = 'offerCalculatorOnSubmit',
  onError = 'offerCalculatorOnError',
  onAnalytics = 'offerCalculatorOnSendAnalytic',
  onReset = 'offerCalculatorOnReset',
}
